import mod from "-!./limit-ekp.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./limit-ekp.js?vue&type=script&lang=js&external"